import React from "react";

const Logo = () => {
  return (
    <div className="logo-container text-center">
      <div className="text-logo">
        <span className="logo-decorative">Friendly Bets</span>
      </div>
    </div>
  );
};

export default Logo;
